import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { FormikField } from 'components/FormikField';
import { EditableTextField, SwitchField } from 'components/FormikFields';
import LessonCatalogCategoryField from 'components/LessonCatalogCategoryField';
import { Typography } from 'components/shared/Typography';

import styles from './LessonHeader.module.scss';

const LessonHeader = ({
  readOnly,
  lessonRole,
}: {
  readOnly: any;
  lessonRole?: any;
}) => (
  <div className={styles.header}>
    <div className={styles.topRow}>
      <FormikField
        name="title"
        withControl={false}
        component={EditableTextField}
        componentProps={{
          className: styles.title,
          readOnly,
          variant: 'heading1',
          placeholder: getTranslation('common.text.untitled'),
        }}
      />

      <div className={styles.controls}>
        {lessonRole === 'CATALOG' && (
          <LessonCatalogCategoryField
            lessonRole={lessonRole}
            readOnly={readOnly}
            labelClassName={styles.freeLabel}
          />
        )}

        <div className={styles.free}>
          <Typography
            className={styles.freeLabel}
            variant="body2"
            weight="medium"
            mode="compact"
          >
            {getTranslation('common.text.free_lesson')}
          </Typography>
          <FormikField
            name="free"
            withControl={false}
            component={SwitchField}
            componentProps={{ readOnly, type: 'checkbox' }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(LessonHeader) as any;
